import { defineStore } from 'pinia'
import { setToken, removeToken, getToken } from '@/utils/auth'



export const useUserStore = defineStore('user', () => {
  const user = ref({
    name: '用户名',
    token: null,
  })
  // 登录态统一以 localStorage 中的 token 为准（与路由守卫、axios 拦截器一致）
  const isLogin = computed(() => !!getToken())
  
  const login = (data) => {
    user.value.name = data.name
    user.value.token = data.token
    setToken(data.token)
  }

  // 退出
  const logout = async () => {
    user.value.name = null
    user.value.token = null

    
    await removeToken()
  }
  return { user, isLogin, login, logout }
}, {
  persist: true,//持久化
})
